import { Trans } from '@lingui/react/macro';

import PlusIcon from '@/assets/svg/bx-plus.svg?react';
import EditAddIcon from '@/assets/svg/edit-add-box.svg?react';
import { Button } from '@/components/buttons';
import InstantSearchInput from '@/components/InstantSearchInput';
import { PendoPlaceholder } from '@/components/PendoPlaceholder';
import { Tooltip, TooltipContent, TooltipTitle, TooltipTrigger } from '@/components/Tooltip';

import RuleFilter from './RuleFilter';

export type ChannelMappingRulesActionsProps = {
  isEditMode: boolean;
  isSaving: boolean;
  canSave: boolean;
  onAddRule: () => void;
  onCancel: () => void;
  onSave: () => void;
  onEnterEditMode: () => void;
};

const ChannelMappingRulesActions = ({
  isEditMode,
  isSaving,
  canSave,
  onAddRule,
  onCancel,
  onSave,
  onEnterEditMode,
}: ChannelMappingRulesActionsProps) => (
  <div className="flex justify-between px-8 pt-6">
    <div>
      {isEditMode && (
        <Button onClick={onAddRule}>
          <PlusIcon />
          <Trans>New Rule</Trans>
        </Button>
      )}
    </div>
    <div className="flex items-center gap-6">
      <PendoPlaceholder />
      {isEditMode && (
        <div className="flex items-center gap-2">
          <Button disabled={isSaving} onClick={onCancel}>
            <Trans>Cancel</Trans>
          </Button>
          <Button variant="primary" disabled={!canSave} isLoading={isSaving} onClick={onSave}>
            <Trans>Save & Run</Trans>
          </Button>
        </div>
      )}
      <div className="flex items-center gap-2">
        {!isEditMode && (
          <Tooltip>
            <TooltipTrigger
              render={
                <Button
                  variant="secondary"
                  shape="square"
                  size="icon"
                  disabled={isSaving}
                  onClick={onEnterEditMode}
                >
                  <EditAddIcon />
                </Button>
              }
            />
            <TooltipContent side="top" align="end" className="flex-col items-start">
              <TooltipTitle>
                <Trans>Add/Edit</Trans>
              </TooltipTitle>
              <span>
                <Trans>Add or Edit Channel Mapping Rules</Trans>
              </span>
            </TooltipContent>
          </Tooltip>
        )}
        <RuleFilter />
        <InstantSearchInput size="medium" />
      </div>
    </div>
  </div>
);

export default ChannelMappingRulesActions;
